/**
 * Valid benefit field names for Accident LOC
 *
 * Used to filter out fields that don't belong to Accident benefits when saving to API.
 * These fields represent the API structure (nested objects created by transforms).
 */

export const ACCIDENT_VALID_FIELDS = new Set([
  "objectType",
  // Nested benefit objects (created by transform, not flat grid fields)
  "coverageType",
  "hospitalAdmission",
  "icuAdmission",
  "dailyHospitalConfinement",
  "dailyIcuConfinement",
  "ambulanceAir",
  "ambulanceGround",
  "emergencyTreatment",
  "urgentCare",
  "initialPhysicianOfficeVisit",
  "dislocationsMaximum",
  "fracturesMaximum",
  "lacerationsMaximum",
  "coma",
  "majorDiagnosticExamXray",
  "majorDiagnosticExamMri",
  "wellnessBenefit",
  // Simple enum fields (not nested)
  "childOrganizedSportsEnhancement",
  "portability",
  "ageReductionSchedule",
  "annualOpenEnrollment",
  // Flat fields
  "benefitClassAvailability",
  "extended",
]);
